import React, { useState } from "react";

import styles from "./textBox.module.scss";
export interface ContentItemsProps {
  title?: string;
  text?: string;
  unit?: string;
  ItemRender?: React.FC;
  TextRender?: React.FC;
  LeftIconRender?: React.FC;
  isDrawable?: boolean;
}

export interface TextBoxProps {
  content: ContentItemsProps[];
  color?: "primary" | "secondary";
  variant?: "dark" | "light";
  style?: React.CSSProperties;
  labelBtn?: string;
  onClick?: () => void;
}

export default function TextBox({
  content,
  color = "secondary",
  variant = "light",
  style,
  labelBtn,
  onClick,
}: TextBoxProps) {

  const [isDrawerOpen, setIsDrawerOpen] = useState(Array(content.length).fill(false));

  const handleDrawerToggle = (index:number) => {
    const newDrawerState = [...isDrawerOpen];
    newDrawerState[index] = !newDrawerState[index];
    setIsDrawerOpen(newDrawerState);
  };

  return (
    <div
      style={style}
      className={[
        styles["text-box"],
        styles["text-box--" + color],
        styles["text-box--" + variant],
        styles["text-box--" + variant + "--" + color],
        onClick ? styles["text-box--" + variant + "--clickable"] : "",
        onClick ? styles["text-box--" + variant + "--" + color + "--clickable"] : "",
        onClick ? styles["text-box--clickable"] : "",
      ].join(" ")}
        onClick={onClick}
    >
      {content.map((item, index) => (
        <div key={index}>
          <div
            className={[
              styles["text-container"],
              styles["text-container--" + variant],
            ].join(" ")}
          >
            <h2
              className={[
                styles["text-container__title"],
                styles["text-container__title--" + variant],
               item.isDrawable ? styles["text-container__title--clickable"] : "",
              ].join(" ")}
              onClick={
                item.isDrawable 
                  ? () => handleDrawerToggle(index)
                  : undefined // Only call onClick if isDrawable is true
              }
            >
              <span style={{display: "flex", justifyContent: "center", alignItems: "center"}}>{item.LeftIconRender &&<span className={styles["text-container__icon"]}> <item.LeftIconRender /></span>}{item.title}</span>{item.isDrawable && <span className={[styles["text-container__icon"], styles["text-container__icon--right"], styles["arrow-icon-drawer"], isDrawerOpen[index] ? styles["arrow-icon-drawer--up"] : styles["arrow-icon-drawer--down"] ].join(" ")}><IconArrow size={8} color="#6A6A6A"  /></span>}
            </h2>
            {(!item.isDrawable || isDrawerOpen[index]) &&
            <>
            {(item.text || item.unit) && (
              <p
                className={[
                  styles["text-container__text"],
                  styles["text-container__textle--" + variant],
                ].join(" ")}
              >
                {item.text} <span>{item.unit}</span>
              </p>
            )}
            {item.ItemRender && (
              <div
                className={[
                  styles["text-container__render"],
                  styles["text-container__render--" + variant],
                ].join(" ")}
              >
                <item.ItemRender />
              </div>
            )}
            {item.TextRender && (
              <p
                className={[
                  styles["text-container__text"],
                  styles["text-container__textle--" + variant],
                ].join(" ")}
              >
                <item.TextRender />
              </p>
            )}
            </>
}
          </div>
        </div>
      ))}
      
      {labelBtn &&
      <div
        className={[
          styles["text-container__footer"],
          styles["footer--" + variant],
          styles["footer"],
        ].join(" ")}
      >
      
        <div
          className={[
            styles["footer__btn"],
            styles["btn"],
            styles["btn--" + variant],
          ].join(" ")}
        >
          <span className={[styles["btn__label"]].join(" ")}>{labelBtn}</span>
          <div className={[styles["btn__icon"]].join(" ")}><IconArrow size={8}  /></div>
        </div>
      </div>
}
    </div>
  );
}

function IconArrow({
  size = 20,
  color = "black",
  
}: {
  size?: number;
  color?: string;
}) {
    return(
  <svg
    width={size}
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 9L5 5L1 1"
        stroke={color}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>);
}
